export default __webpack_public_path__ + "static/2-0cdc3e3febda453cda472820581654a9.jpg";